import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react'
import contactStyle from "../../../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss";
import globalStyles from "../../../../../../assets/styles/global.module.scss";
import whatsAppCampaignStyles from "../../../../../../assets/styles/componentStyles/whatsappCampaignStyles/whatsappCampaignStyle.module.scss";
import styles from "../../../../../../assets/styles/componentStyles/chatbotStyles/chats.module.scss";
import { Autocomplete, Divider, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography, useMediaQuery } from '@mui/material';
import { campaignCarouselCard, createCampaignCampaignVariable, createWhatsappTemplatePayload, currentActiveChatbotThreadTypeNew, getTemplateDetails, sendCannedResponsePayload, sendTemplatePayload, templateVariable, uploadedMedia, whatsappTemplateButton, whatsappTemplateButtonData, whatsappTemplateHeaderVariable } from '../../../../../../models/axiosModel';
import Required from '../../../../../../components/utility/required';
import previewIcon from '../../../../../../assets/chatbotAssets/Chatbot-Preview-Arrow.svg'
import { defaultCreateTemplatePayload } from '../../../../../../components/dashboard/whatsappCampaign/whatsappCampaign';
import BasicTemplatePreview from '../../../../../../components/dashboard/channels/global/whatsapp/templates/previews/basicTemplatePreview';
import TemplatePreviewMobile from '../../../../../../components/dashboard/channels/global/whatsapp/templates/previews/basicTemplatePreviewMobile'
import { WhatsappCampaignContext, WhatsappCampaignContextPayload } from '../../../../../../context/whatsappCampaignContext';
import { UserContext, UserContextPayload } from '../../../../../../context/userContext';
import { checkIfBtnDynamicVarExist, checkInternetConnection, getFileTypeImgIcon, getWhatsappMediaAllowedFileTypes, getWhatsappMediaSizeLimit, getWabaName } from '../../../../../../utils/constants';
import GlobalButton from '../../../../../../components/utility/globalButton/button';
import FileUpload from '../../../../../../components/utility/fileUpload/fileUpload';
import validator from 'validator';
import { debounce } from 'lodash';
import { renderTemplateOptions } from '../../../../../../components/dashboard/channels/global/whatsapp/templates/utils';
import { getVisitWebsiteUrl, isCarouselTemplate } from '../../../../../../components/dashboard/whatsappCampaign/campaignConstant';
import { WhatsappFlow, WhatsappFlowVariable } from '../../../../../../components/dashboard/channels/global/whatsapp/flows/waFlowTypes';
import TemplatePreviewCarouselView from '../../../../../../components/dashboard/channels/global/whatsapp/templates/previews/TemplatePreviewCarouselView';
import CarouselTemplateVariableMapping from './carouselTemplateVariableMapping';
import agent from '../../../../../../services/api';
import TemplatePreviewCarouselMobileView from '../../../../../../components/dashboard/channels/global/whatsapp/templates/previews/TemplatePreviewCarouselMobileView';
import { useTemplateLibraryStore } from '../../../../../../store/templateLibraryStore';
import { useShallow } from 'zustand/react/shallow';
import { useRuleBasedInboxStore } from '../../../../../../store/ruleBasedInboxStore';
import { getDefaultSendTemplatePayload, getMetadataValue, getThreadData } from '../../../../utils';
import { IntegrationContext, IntegrationContextPayload } from '../../../../../../context/integrationContext';
import { buildTemplateActionExecutionData } from '../../pendingManualMessageUtils';
import { useGenericStore } from '../../../../../../store/genericStore';
import { METADATA_KEYS, TEMPLATE_META_DATA_OPTIONS } from '../../../../constants';
import { getLocationCoordinateWarning, isValidLatitudeValue, isValidLongitudeValue } from '../../../../../../components/dashboard/templatelibrary/constant';

// ── Pure module-level helpers (no closure dependencies) ──────────────────────

const isMediaHeaderType = (headerType: string = "") =>
    ['image', 'video', 'document', 'gif'].includes(headerType.toLowerCase());

const getVariableDataObj = (variable_id: number, variable_type: string, flag_flow_variable: boolean) => ({
    variable_id,
    variable_value: "",
    variable_replaced_value: "",
    variable_google_storage_id: null,
    variable_type,
    flag_flow_variable,
});

const getAllButtonVariableData = (button: whatsappTemplateButton[]): whatsappTemplateHeaderVariable[] =>
    button.flatMap(btn =>
        btn.whatsapp_template_button_data.flatMap((data: whatsappTemplateButtonData) =>
            data.whatsapp_template_button_sub_type_field_data.flatMap(field =>
                field.whatsapp_template_button_field_data_variable || []
            )
        )
    );

const buildCarouselTemplatePayload = (
    messageTemplateDetail: getTemplateDetails,
    fallBackVal: createCampaignCampaignVariable[],
    campaign_carousel_card: campaignCarouselCard[]
): getTemplateDetails => ({
    ...messageTemplateDetail,
    whtatsapp_carousel_header_variable_data: messageTemplateDetail.whtatsapp_carousel_header_variable_data?.map((variable) => {
        const currentVal = fallBackVal.find(
            (fb) => fb.whatsapp_template_dynamic_variable_id === variable.whatsapp_template_dynamic_variable_id
        );
        const sampleValue = currentVal
            ? (currentVal.campaign_variable_name || currentVal.campaign_variable_fallback_value)
            : variable.whatsapp_template_dynamic_variable_key;
        return { ...variable, whatsapp_template_dynamic_variable_sample_value: sampleValue };
    }),
    whatsapp_template_data: messageTemplateDetail?.whatsapp_template_data?.map((template) => ({
        ...template,
        whatsapp_template_header: {
            ...template.whatsapp_template_header,
            whatsapp_template_header_data: template.whatsapp_template_header?.whatsapp_template_header_data?.map((header) => {
                const sampleValue =
                    campaign_carousel_card
                        ?.find((card) => card.whatsapp_template_carousel_variation_id === template.whatsapp_template_carousel_variation_id)
                        ?.campaign_variable?.find(
                            (vari) => vari.whatsapp_template_dynamic_variable_id === header.whatsapp_template_header_variable_data[0]?.whatsapp_template_dynamic_variable_id
                        )?.campaign_variable_fallback_value
                    || header?.whatsapp_template_header_variable_data?.[0]?.whatsapp_template_dynamic_variable_sample_value;
                return { ...header, whatsapp_template_header_data_value: sampleValue };
            }),
        },
        whatsapp_template_body: {
            ...template.whatsapp_template_body,
            whatsapp_template_body_variable_data: template.whatsapp_template_body?.whatsapp_template_body_variable_data?.map((bVariable) => {
                const sampleValue =
                    campaign_carousel_card
                        ?.find((card) => card.whatsapp_template_carousel_variation_id === template.whatsapp_template_carousel_variation_id)
                        ?.campaign_variable?.find(
                            (v) => v.whatsapp_template_dynamic_variable_id === bVariable.whatsapp_template_dynamic_variable_id
                        )?.campaign_variable_fallback_value
                    || bVariable.whatsapp_template_dynamic_variable_key;
                return { ...bVariable, whatsapp_template_dynamic_variable_sample_value: sampleValue };
            }),
        },
        whatsapp_template_button: template.whatsapp_template_button?.map((btn) => ({
            ...btn,
            whatsapp_template_button_data: btn.whatsapp_template_button_data.map((btnData) => ({
                ...btnData,
                whatsapp_template_button_sub_type_field_data: btnData.whatsapp_template_button_sub_type_field_data?.map((subTypeField) => ({
                    ...subTypeField,
                    whatsapp_template_button_field_data_variable: subTypeField.whatsapp_template_button_field_data_variable?.map((btnVariable) => {
                        const sampleValue =
                            campaign_carousel_card
                                ?.find((card) => card.whatsapp_template_carousel_variation_id === template.whatsapp_template_carousel_variation_id)
                                ?.campaign_variable?.find(
                                    (v) => v?.whatsapp_template_dynamic_variable_id === btnVariable?.whatsapp_template_dynamic_variable_id
                                )?.campaign_variable_fallback_value
                            || btnVariable.whatsapp_template_dynamic_variable_sample_value;
                        return { ...btnVariable, whatsapp_template_dynamic_variable_sample_value: sampleValue };
                    }),
                })),
            })),
        })),
    })),
});

// ── Component ─────────────────────────────────────────────────────────────────

interface SelectTemplatePopupProps {
    templateList: getTemplateDetails[] | null,
    setFlagSelectTemplatePopup: React.Dispatch<React.SetStateAction<boolean>>,
    handleSendMessageManually: (inputValue: string, flagMediaMessage: boolean, flagCannedResponseTemplate: boolean, flagTemplateMessage: boolean, selectedMediaSet: uploadedMedia[], sendTemplatePayload: sendTemplatePayload | null, cannedResponsePayload?: sendCannedResponsePayload) => Promise<void>,
}

const SelectTemplatePopup: React.FC<SelectTemplatePopupProps> = (props) => {
    const { templateList, setFlagSelectTemplatePopup, handleSendMessageManually } = props;

    const { messageTemplateDetail, setMessageTemplateDetail, getWhatsappTemplateDetailsApiCall } = useContext(WhatsappCampaignContext) as WhatsappCampaignContextPayload;
    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload;
    const { integrationListNewStructure } = useContext(IntegrationContext) as IntegrationContextPayload;

    const templateCategoryList = useTemplateLibraryStore((state) => state.templateLibraryCategoryList);

    const { showSuccess, showError } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess,
        showError: state.showError,
    })));

    const { newThreadInfo, flagRenderNewConversation, currentActiveChatbotThread } = useRuleBasedInboxStore(useShallow((state) => ({
        newThreadInfo: state.newThreadInfo,
        flagRenderNewConversation: state.flagRenderNewConversation,
        currentActiveChatbotThread: state.currentActiveChatbotThread as currentActiveChatbotThreadTypeNew,
    })));

    const wabaName = getWabaName(
        integrationListNewStructure,
        Number(getThreadData('metaIntegrationWhatsAppId', currentActiveChatbotThread, newThreadInfo, integrationListNewStructure)),
        "WhatsApp Business"
    );

    const [sendTemplatePayload, setSendTemplatePayload] = useState<sendTemplatePayload>(
        getDefaultSendTemplatePayload(
            currentActiveChatbotThread?.thread_id ?? '',
            String(getThreadData('userWAPhoneNumber', currentActiveChatbotThread, newThreadInfo, integrationListNewStructure)) ?? '',
            String(getThreadData('integratedChannelId', currentActiveChatbotThread, newThreadInfo, integrationListNewStructure)) ?? ''
        )
    );

    const [createTemplatePayload, setCreateTemplatePayload] = useState<createWhatsappTemplatePayload>(defaultCreateTemplatePayload(templateCategoryList ?? []));
    const [carouselTemplatePayload, setCarouselTemplatePayload] = useState<getTemplateDetails | null>(null);
    const [buttonData, setButtonData] = useState<whatsappTemplateHeaderVariable[] | null>(null);
    const [openSwipableDrawer, setOpenSwipableDrawer] = useState<boolean>(false);
    const [files, setFiles] = useState<any>([]);
    const [isFileUploaded, setIsFileUploaded] = useState<boolean>(false);
    const [inValidId, setInvalidId] = useState<any[]>([]);

    const inValidIdRef = useRef<any[]>([]);
    const [whatsappFlowData, setWhatsappFlowData] = useState<WhatsappFlow[] | null>(null);

    const innerHeight = window.innerHeight - 250;
    const flagLargeScreen = useMediaQuery<boolean>('(min-width: 0px) and (max-width: 1200px)');
    const flagTabletScreen = useMediaQuery('(max-width : 768px) and (min-width : 0px)');

    // ── Derived/computed values ───────────────────────────────────────────────

    const flagShowHeaderVariables = useMemo(() =>
        Boolean(
            messageTemplateDetail?.whatsapp_template_data?.[0]?.whatsapp_template_header
                ?.whatsapp_template_header_data?.[0]?.whatsapp_template_header_variable_data?.length
        ),
        [messageTemplateDetail]
    );

    const flagShowBodyVariable = useMemo(() =>
        Boolean(messageTemplateDetail?.whatsapp_template_data?.[0]?.whatsapp_template_body?.whatsapp_template_body_variable_data?.length),
        [messageTemplateDetail]
    );

    const flagShowButtonVariable = useMemo(() =>
        Boolean(
            messageTemplateDetail?.whatsapp_template_data?.[0]?.whatsapp_template_button?.length &&
            checkIfBtnDynamicVarExist(messageTemplateDetail.whatsapp_template_data[0].whatsapp_template_button)
        ),
        [messageTemplateDetail]
    );

    const isHeaderTypeLocation = useMemo(() =>
        messageTemplateDetail?.whatsapp_template_data?.[0]?.whatsapp_template_header?.whatsapp_template_header_type_name?.toLowerCase() === "location",
        [messageTemplateDetail]
    );

    const flagShowInputFlowVariabless = useMemo(() =>
        whatsappFlowData?.some(waFlow =>
            waFlow?.whatsapp_flow_version_data?.some(
                version =>
                    version?.whatsapp_flow_metadata_response?.whatsapp_flow_meta_status?.toLowerCase() === "published" &&
                    version?.whatsapp_flow_variables?.some((v) => v?.input_variable_flag)
            )
        ) ?? false,
        [whatsappFlowData]
    );

    const isDisabledSendBtn = useMemo(() => {
        if (!sendTemplatePayload.whatsapp_template_id || !sendTemplatePayload.integrated_channel_id || inValidId.length > 0) {
            return true;
        }
        for (const variable of sendTemplatePayload.template_variable_data) {
            if (variable.flag_flow_variable) continue;
            if (variable.variable_type === "text") {
                if (!variable.variable_value?.trim() && !variable.variable_replaced_value?.trim()) return true;
            } else {
                if (!variable.variable_value?.trim()) return true;
            }
        }
        return false;
    }, [sendTemplatePayload, inValidId]);

    const metaDataOptions = useMemo(() => {
        const variables = flagRenderNewConversation
            ? TEMPLATE_META_DATA_OPTIONS.filter((v) => v.key !== "name")
            : TEMPLATE_META_DATA_OPTIONS;
        return variables.map((v) => v.label);
    }, [flagRenderNewConversation]);

    // ── Stable handlers ───────────────────────────────────────────────────────

    const toggleDrawer = useCallback((newOpen: boolean) => () => {
        setOpenSwipableDrawer(newOpen);
    }, []);

    const handleValidWebsite = useCallback((website_value: any, index: any) => {
        if (website_value.trim().length > 0) {
            const isValid = validator.isURL(website_value);
            if (isValid) {
                if (inValidIdRef.current.includes(index)) {
                    inValidIdRef.current = inValidIdRef.current.filter((ele) => ele !== index);
                    setInvalidId(inValidIdRef.current);
                }
            } else {
                if (!inValidIdRef.current.includes(index)) {
                    inValidIdRef.current = [...inValidIdRef.current, index];
                    setInvalidId(inValidIdRef.current);
                }
            }
        } else if (website_value.trim().length === 0) {
            if (inValidIdRef.current.includes(index)) {
                inValidIdRef.current = inValidIdRef.current.filter((ele) => ele !== index);
                setInvalidId(inValidIdRef.current);
            }
        }
    }, []);

    const handleValidLocationCoordinate = useCallback((value: string, variableKey: string, index: any) => {
        const normalizedKey = variableKey?.toLowerCase() ?? "";
        const isValid = normalizedKey === "{{latitude}}"
            ? isValidLatitudeValue(value)
            : normalizedKey === "{{longitude}}"
                ? isValidLongitudeValue(value)
                : true;

        if (isValid) {
            if (inValidIdRef.current.includes(index)) {
                inValidIdRef.current = inValidIdRef.current.filter((ele) => ele !== index);
                setInvalidId(inValidIdRef.current);
            }
        } else if (!inValidIdRef.current.includes(index)) {
            inValidIdRef.current = [...inValidIdRef.current, index];
            setInvalidId(inValidIdRef.current);
        }
    }, []);

    // Stable debounced URL validator — deps are empty because handleValidWebsite uses only refs/setters
    const onBlurOfValue = useCallback(
        debounce((value: any, index: any) => {
            handleValidWebsite(value, index);
        }, 1200),
        [] // eslint-disable-line react-hooks/exhaustive-deps
    );

    const setHeaderVariableSampleValue = useCallback((value: string) => {
        setCreateTemplatePayload((prev) => ({
            ...prev,
            whatsapp_template_data: {
                ...prev.whatsapp_template_data,
                whatsapp_template_header: {
                    ...prev.whatsapp_template_data.whatsapp_template_header,
                    whatsapp_template_header_data: prev.whatsapp_template_data.whatsapp_template_header.whatsapp_template_header_data.map((hVariable) => ({
                        ...hVariable,
                        whatsapp_template_header_data_value: value.trim().length > 0 ? value.trim() : hVariable.whatsapp_template_header_data_value,
                    })),
                },
            },
        }));
    }, []);

    const handleChangeValue = useCallback((
        value: any,
        variableType: string,
        variable: whatsappTemplateHeaderVariable | WhatsappFlowVariable,
        whatsapp_template_carousel_variation_id: number,
        type?: string
    ) => {
        const variableId = "whatsapp_template_dynamic_variable_id" in variable
            ? variable.whatsapp_template_dynamic_variable_id
            : variable.whatsapp_flow_variable_id;

        // Update the flat variable payload (functional update — no sendTemplatePayload in closure)
        setSendTemplatePayload((prev) => ({
            ...prev,
            template_variable_data: prev.template_variable_data.map((variableData) =>
                variableData?.variable_id === variableId
                    ? { ...variableData, variable_value: value }
                    : variableData
            ),
        }));

        switch (variableType.toLowerCase()) {
            case "header":
                if (type) {
                    switch (type.toLowerCase()) {
                        case "text":
                            setHeaderVariableSampleValue(value);
                            break;
                        case "image":
                        case "video":
                        case "document":
                            onBlurOfValue(value, variableId);
                            break;
                        case "location":
                            setCreateTemplatePayload((prev) => ({
                                ...prev,
                                whatsapp_template_data: {
                                    ...prev.whatsapp_template_data,
                                    whatsapp_template_header: {
                                        ...prev.whatsapp_template_data.whatsapp_template_header,
                                        whatsapp_template_header_data: prev.whatsapp_template_data.whatsapp_template_header.whatsapp_template_header_data.map((hVariable) => ({
                                            ...hVariable,
                                            whatsapp_template_header_variable_data: hVariable?.whatsapp_template_header_variable_data?.map((vari) =>
                                                vari?.whatsapp_template_dynamic_variable_id === variableId
                                                    ? { ...vari, whatsapp_template_dynamic_variable_sample_value: value.trim().length > 0 ? value.trim() : vari?.whatsapp_template_dynamic_variable_key }
                                                    : vari
                                            ),
                                        })),
                                    },
                                },
                            }));
                            if ("whatsapp_template_dynamic_variable_id" in variable) {
                                const variableKey = variable?.whatsapp_template_dynamic_variable_key ?? "";
                                if (["{{latitude}}", "{{longitude}}"].includes(variableKey.toLowerCase())) {
                                    handleValidLocationCoordinate(value, variableKey, variableId);
                                }
                            }
                            break;
                    }
                }
                break;

            case "body":
                setCreateTemplatePayload((prev) => ({
                    ...prev,
                    whatsapp_template_data: {
                        ...prev.whatsapp_template_data,
                        whatsapp_template_body: {
                            ...prev.whatsapp_template_data.whatsapp_template_body,
                            whatsapp_template_body_variable_data: prev.whatsapp_template_data.whatsapp_template_body.whatsapp_template_body_variable_data.map((vari) =>
                                vari?.whatsapp_template_dynamic_variable_id === variableId
                                    ? { ...vari, whatsapp_template_dynamic_variable_sample_value: value.trim().length > 0 ? value.trim() : vari.whatsapp_template_dynamic_variable_key }
                                    : vari
                            ),
                        },
                    },
                }));
                break;

            case "button":
                break;

            case "carousel card header":
                onBlurOfValue(value, variableId);
                setCarouselTemplatePayload((prev) => {
                    if (!prev) return prev;
                    return {
                        ...prev,
                        whatsapp_template_data: prev?.whatsapp_template_data?.map((template) =>
                            template.whatsapp_template_carousel_variation_id === whatsapp_template_carousel_variation_id
                                ? {
                                    ...template,
                                    whatsapp_template_header: {
                                        ...template.whatsapp_template_header,
                                        whatsapp_template_header_data: template.whatsapp_template_header?.whatsapp_template_header_data?.map((v) => ({
                                            ...v,
                                            whatsapp_template_header_data_value: value,
                                        })),
                                    },
                                }
                                : template
                        ),
                    };
                });
                break;

            case "carousel card body":
                setCarouselTemplatePayload((prev) => {
                    if (!prev) return prev;
                    return {
                        ...prev,
                        whatsapp_template_data: prev?.whatsapp_template_data?.map((template) =>
                            template.whatsapp_template_carousel_variation_id === whatsapp_template_carousel_variation_id
                                ? {
                                    ...template,
                                    whatsapp_template_body: {
                                        ...template.whatsapp_template_body,
                                        whatsapp_template_body_variable_data: template.whatsapp_template_body?.whatsapp_template_body_variable_data?.map((bVariable) =>
                                            bVariable.whatsapp_template_dynamic_variable_id === variableId
                                                ? { ...bVariable, whatsapp_template_dynamic_variable_sample_value: value }
                                                : bVariable
                                        ),
                                    },
                                }
                                : template
                        ),
                    };
                });
                break;

            case "carousel card button":
                setCarouselTemplatePayload((prev) => {
                    if (!prev) return prev;
                    return {
                        ...prev,
                        whatsapp_template_data: prev?.whatsapp_template_data?.map((template) =>
                            template.whatsapp_template_carousel_variation_id === whatsapp_template_carousel_variation_id
                                ? {
                                    ...template,
                                    whatsapp_template_button: template.whatsapp_template_button?.map((button) => ({
                                        ...button,
                                        whatsapp_template_button_data: button.whatsapp_template_button_data?.map((btnData) => ({
                                            ...btnData,
                                            whatsapp_template_button_sub_type_field_data: btnData.whatsapp_template_button_sub_type_field_data?.map((subTypeFieldData) => ({
                                                ...subTypeFieldData,
                                                whatsapp_template_button_field_data_variable: subTypeFieldData.whatsapp_template_button_field_data_variable?.map((btnFieldVariable) =>
                                                    btnFieldVariable.whatsapp_template_dynamic_variable_id === variableId
                                                        ? { ...btnFieldVariable, whatsapp_template_dynamic_variable_sample_value: value }
                                                        : btnFieldVariable
                                                ),
                                            })),
                                        })),
                                    })),
                                }
                                : template
                        ),
                    };
                });
                break;

            case "carousel body":
                setCarouselTemplatePayload((prev) => {
                    if (!prev) return prev;
                    return {
                        ...prev,
                        whtatsapp_carousel_header_variable_data: prev.whtatsapp_carousel_header_variable_data?.map((hVariable) =>
                            hVariable.whatsapp_template_dynamic_variable_id === variableId
                                ? { ...hVariable, whatsapp_template_dynamic_variable_sample_value: value.trim().length > 0 ? value : hVariable.whatsapp_template_dynamic_variable_key }
                                : hVariable
                        ),
                    };
                });
                break;
        }
    }, [setHeaderVariableSampleValue, onBlurOfValue, handleValidLocationCoordinate]);

    const uploadFileHandler = useCallback(async (
        e: React.ChangeEvent<HTMLInputElement>,
        variable: whatsappTemplateHeaderVariable,
        whatsapp_template_carousel_variation_id?: number
    ) => {
        if (!e.target.files) return;

        for (let i = 0; i < e.target.files.length; i++) {
            const file: any = e.target.files[i];
            file.isUploading = true;
            setFiles([file]);

            const formData = new FormData();
            formData.append("file", file, file.name);
            formData.append("chatbot_flag", "true");

            setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
            await agent.uploadFile.post(formData).then(async (res) => {
                if (res.status) {
                    file.isUploading = false;
                    file.file_data = res.data.data;
                    file.google_storage_id = res.data.data.google_storage_id;

                    await setFiles((old: any) => {
                        const temp = [...old];
                        const fileTypeIconSrc = getFileTypeImgIcon(file.name.split('.').pop()) ?? "";
                        temp.forEach((rr: any) => {
                            if (rr.google_storage_id === file.google_storage_id) {
                                rr.isUploading = false;
                                rr.file_data = res.data.data;
                                rr.google_storage_id = res.data.data.google_storage_id;
                                rr.previewImageSrc = fileTypeIconSrc;
                            }
                        });
                        return temp;
                    });

                    if (whatsapp_template_carousel_variation_id) {
                        handleChangeValue(res.data.data.file_path, "carousel card header", variable, whatsapp_template_carousel_variation_id);
                    }

                    setSendTemplatePayload((prev) => ({
                        ...prev,
                        template_variable_data: prev.template_variable_data.map((vari) => {
                            if (vari?.variable_id === variable?.whatsapp_template_dynamic_variable_id) {
                                return {
                                    ...vari,
                                    variable_value: res.data.data.file_path,
                                    variable_google_storage_id: res.data.data.google_storage_id,
                                    variable_type: "media",
                                };
                            }
                            return vari;
                        }),
                    }));

                    setHeaderVariableSampleValue(res.data.data.file_path);
                    setIsFileUploaded(false);
                }
            }).catch((err) => {
                showError("Something went wrong!");
                setFiles([]);
                console.error(err);
            });
            setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
        }
    }, [handleChangeValue, setHeaderVariableSampleValue, showError]); // eslint-disable-line react-hooks/exhaustive-deps

    const removeFileHandler = useCallback(async () => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        await agent.removeUploadedFile.delete(files[0].file_data.google_storage_id).then(async (res) => {
            if (res.data.status) {
                setFiles([]);
                showSuccess("File Deleted Successfully");
            } else {
                handleError(res.data);
            }
        }).catch((err) => {
            console.log(err);
        });
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
        setFiles([]);
    }, [files, showSuccess, handleError]); // eslint-disable-line react-hooks/exhaustive-deps

    const flagShowFlowVariables = useCallback((detail: any): boolean =>
        Boolean(
            detail?.whatsapp_template_data?.[0]?.whatsapp_template_button?.find((btn: any) =>
                btn.whatsapp_template_button_data?.find((btnData: any) =>
                    btnData?.whatsapp_template_button_type_name?.toLowerCase() === "flow" &&
                    btnData?.whatsapp_template_button_sub_type_name?.toLowerCase() === "open form"
                )
            )
        ),
        []
    );

    const getWhatsappTemplateDetailsApi = useCallback(async (
        meta_integration_whatsapp_id: number,
        whatsapp_template_id: number
    ) => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        const res = await getWhatsappTemplateDetailsApiCall(meta_integration_whatsapp_id, whatsapp_template_id);
        if (!res.status) {
            handleError(res);
        } else {
            const templateDetails = res.data[0];
            if (flagShowFlowVariables(templateDetails)) {
                let waFlowData: WhatsappFlow[] | null = null;
                templateDetails?.whatsapp_template_data?.[0]?.whatsapp_template_button?.forEach((btn: whatsappTemplateButton) => {
                    const buttonData = btn?.whatsapp_template_button_data?.find((btnData: whatsappTemplateButtonData) =>
                        btnData?.whatsapp_template_button_type_name?.toLowerCase() === "flow" &&
                        btnData?.whatsapp_template_button_sub_type_name?.toLowerCase() === "open form"
                    );
                    if (buttonData) {
                        waFlowData = waFlowData ? [...waFlowData, buttonData?.whatsapp_flow_data] : [buttonData?.whatsapp_flow_data];
                    }
                });
                setWhatsappFlowData(waFlowData);
            } else {
                setWhatsappFlowData(null);
            }
        }
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
    }, [getWhatsappTemplateDetailsApiCall, handleError, flagShowFlowVariables]); // eslint-disable-line react-hooks/exhaustive-deps

    const setCreateTemplatePayloadFromDetails = useCallback((detail: getTemplateDetails) => {
        setCreateTemplatePayload({
            whatsapp_template_id: detail.whatsapp_template_id,
            meta_integration_whatsapp_id: detail.meta_integration_whatsapp_id,
            whatsapp_template_type_id: detail.whatsapp_template_type?.whatsapp_template_type_id ?? 0,
            whatsapp_template_type: detail.whatsapp_template_type,
            whatsapp_template_data: {
                whatsapp_template_data_id: null,
                whatsapp_template_category_id: Number(detail.whatsapp_template_data?.[0].whatsapp_template_category_id ?? 0),
                whatsapp_language_id: detail.whatsapp_template_data?.[0].whatsapp_language_data?.whatsapp_language_id ?? null,
                whatsapp_template_name: detail.whatsapp_template_data?.[0].whatsapp_template_name ?? "",
                whatsapp_template_display_name: detail.whatsapp_template_data?.[0].whatsapp_template_display_name ?? "",
                whatsapp_template_description: detail.whatsapp_template_data?.[0].whatsapp_template_description ?? "",
                //@ts-ignore
                whatsapp_template_button: detail.whatsapp_template_data?.[0].whatsapp_template_button?.map((button) => ({
                    whatsapp_template_button_id: button.whatsapp_template_button_id ?? null,
                    whatsapp_template_button_type_id: Number(button.whatsapp_template_button_type_id),
                    whatsapp_template_button_type_name: button.whatsapp_template_button_type_name,
                    whatsapp_template_button_index: button.whatsapp_template_button_index,
                    whatsapp_template_button_data: button.whatsapp_template_button_data?.map((buttonData) => ({
                        ...buttonData,
                        whatsapp_template_button_sub_type_field_data: buttonData.whatsapp_template_button_sub_type_field_data?.map((subField) => ({
                            ...subField,
                            whatsapp_template_button_field_data_variable: subField.whatsapp_template_button_field_data_variable ?? null,
                        })),
                    })),
                })) ?? [],
                whatsapp_template_header: {
                    whatsapp_template_header_type_id: detail.whatsapp_template_data?.[0].whatsapp_template_header?.whatsapp_template_header_type_id ?? null,
                    whatsapp_template_header_type_name: detail.whatsapp_template_data?.[0].whatsapp_template_header?.whatsapp_template_header_type_name ?? "",
                    whatsapp_template_header_data: detail.whatsapp_template_data?.[0].whatsapp_template_header?.whatsapp_template_header_data?.flatMap((header) => ({
                        whatsapp_template_header_data_value: header.whatsapp_template_header_data_value,
                        whatsapp_template_header_data_id: header.whatsapp_template_header_data_id,
                        whatsapp_template_header_data_google_storage_id: header.whatsapp_template_header_data_google_storage_id,
                        whatsapp_template_header_variable_data: header.whatsapp_template_header_variable_data?.flatMap((hVariable) => ({
                            whatsapp_template_dynamic_variable_id: hVariable?.whatsapp_template_dynamic_variable_id,
                            whatsapp_template_dynamic_variable_type_id: hVariable?.whatsapp_template_dynamic_variable_type_id,
                            whatsapp_template_dynamic_variable_unique_id: hVariable?.whatsapp_template_dynamic_variable_unique_id,
                            whatsapp_template_dynamic_variable_key: hVariable?.whatsapp_template_dynamic_variable_key,
                            whatsapp_template_dynamic_variable_sample_value: hVariable?.whatsapp_template_dynamic_variable_key,
                            flag_header: hVariable?.flag_header,
                            flag_button: hVariable?.flag_button,
                            whatsapp_template_dynamic_variable_type_name: hVariable?.whatsapp_template_dynamic_variable_type_name,
                        })) ?? [],
                    })) ?? [],
                },
                whatsapp_template_body: {
                    whatsapp_template_body_value: detail.whatsapp_template_data?.[0].whatsapp_template_body?.whatsapp_template_body_value ?? "",
                    whatsapp_template_body_description: detail.whatsapp_template_data?.[0].whatsapp_template_body?.whatsapp_template_body_description ?? "",
                    whatsapp_template_body_variable_data: detail.whatsapp_template_data?.[0].whatsapp_template_body?.whatsapp_template_body_variable_data?.flatMap((variable) => ({
                        whatsapp_template_dynamic_variable_id: variable?.whatsapp_template_dynamic_variable_id,
                        whatsapp_template_dynamic_variable_type_id: variable?.whatsapp_template_dynamic_variable_type_id,
                        whatsapp_template_dynamic_variable_unique_id: variable?.whatsapp_template_dynamic_variable_unique_id,
                        whatsapp_template_dynamic_variable_key: variable?.whatsapp_template_dynamic_variable_key,
                        whatsapp_template_dynamic_variable_sample_value: variable?.whatsapp_template_dynamic_variable_key,
                        flag_header: variable?.flag_header,
                        flag_button: variable?.flag_button,
                        whatsapp_template_dynamic_variable_type_name: variable?.whatsapp_template_dynamic_variable_type_name,
                    })) ?? [],
                },
                whatsapp_template_footer: {
                    whatsapp_template_footer_id: detail.whatsapp_template_data?.[0].whatsapp_template_footer?.whatsapp_template_footer_id,
                    whatsapp_template_footer_value: detail.whatsapp_template_data?.[0].whatsapp_template_footer?.whatsapp_template_footer_value,
                },
            },
            whatsapp_template_flag_interactive_message: detail?.whatsapp_template_flag_interactive_message,
        });
    }, []);

    const setDefaultTemplateVariable = useCallback((
        headerData: any,
        headerType: string,
        bodyData: any,
        buttonData: any,
        flowVariables: any,
        flag_carousel: boolean
    ): templateVariable[] => {
        const varArray: templateVariable[] = [
            ...headerData.map((h: any) => getVariableDataObj(h?.whatsapp_template_dynamic_variable_id, isMediaHeaderType(headerType) ? "media" : "text", false)),
            ...bodyData.map((b: any) => getVariableDataObj(b?.whatsapp_template_dynamic_variable_id, "text", false)),
            ...buttonData.map((b: any) => getVariableDataObj(b?.whatsapp_template_dynamic_variable_id, "media", false)),
        ];

        if (flowVariables) {
            flowVariables.forEach((fv: any) => {
                varArray.push(getVariableDataObj(fv?.whatsapp_flow_variable_id, "text", true));
            });
        }

        if (!flag_carousel) {
            setSendTemplatePayload((prev) => ({ ...prev, template_variable_data: varArray }));
        }
        return varArray;
    }, []);

    const setCarouselGlobalHeaderData = useCallback((carouselGlobalHeaderData: any): templateVariable[] =>
        carouselGlobalHeaderData.map((h: any) =>
            getVariableDataObj(h?.whatsapp_template_dynamic_variable_id, "text", false)
        ),
        []
    );

    const onChangeOfTemplate = useCallback((value: getTemplateDetails | null) => {
        setSendTemplatePayload((prev) => ({
            ...prev,
            whatsapp_template_id: value ? value.whatsapp_template_id : 0,
        }));
        if (value) {
            const metaIntegrationWhatsAppId = getThreadData('metaIntegrationWhatsAppId', currentActiveChatbotThread, newThreadInfo, integrationListNewStructure) as number;
            getWhatsappTemplateDetailsApi(metaIntegrationWhatsAppId, value.whatsapp_template_id);
        } else {
            setMessageTemplateDetail(null);
        }
    }, [currentActiveChatbotThread, newThreadInfo, integrationListNewStructure, getWhatsappTemplateDetailsApi, setMessageTemplateDetail]);

    const onChangeOfValue = useCallback((
        value: string | null,
        variable: whatsappTemplateHeaderVariable | WhatsappFlowVariable
    ) => {
        const variableId = "whatsapp_template_dynamic_variable_id" in variable
            ? variable.whatsapp_template_dynamic_variable_id
            : variable.whatsapp_flow_variable_id;

        setSendTemplatePayload((prev) => ({
            ...prev,
            template_variable_data: prev.template_variable_data.map((variableData) =>
                variableData?.variable_id === variableId
                    ? { ...variableData, variable_replaced_value: value ?? "" }
                    : variableData
            ),
        }));
    }, []);

    const updatedIndexForBtnVariable = useCallback((ind: number): number => {
        if (!messageTemplateDetail) return ind;
        let updatedInd = ind;
        if (flagShowHeaderVariables) {
            updatedInd += messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_header.whatsapp_template_header_data[0].whatsapp_template_header_variable_data.length;
        }
        if (flagShowBodyVariable) {
            updatedInd += messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_body.whatsapp_template_body_variable_data.length;
        }
        return updatedInd;
    }, [messageTemplateDetail, flagShowHeaderVariables, flagShowBodyVariable]);

    const onClickOfCancel = useCallback(() => {
        setButtonData(null);
        setInvalidId([]);
        inValidIdRef.current = [];
        setMessageTemplateDetail(null);
        setFlagSelectTemplatePopup(false);
    }, [currentActiveChatbotThread, templateCategoryList, setMessageTemplateDetail, setFlagSelectTemplatePopup]);

    const onClickOfSend = useCallback(async () => {
        if (!checkInternetConnection()) return;

        // Resolve variable_replaced_value → actual value at send time
        const resolvedTemplateVariableData = sendTemplatePayload.template_variable_data.map((variable) => {
            if (variable.variable_type === "text" && variable.variable_replaced_value?.trim()) {
                let replacedValue = "";
                switch (variable.variable_replaced_value.toLowerCase()) {
                    case 'name':
                        replacedValue = getMetadataValue(currentActiveChatbotThread?.thread_metadata, METADATA_KEYS['NAME']) ?? variable?.variable_value ?? '';
                        break;
                    case 'phone number':
                        replacedValue = String(getThreadData('userWAPhoneNumber', currentActiveChatbotThread, newThreadInfo, integrationListNewStructure)) ?? variable?.variable_value ?? '';
                        break;
                    default:
                        replacedValue = variable?.variable_value ?? '';
                }
                return { ...variable, variable_value: replacedValue };
            }
            return variable;
        });

        let payload = { ...sendTemplatePayload, template_variable_data: resolvedTemplateVariableData };

        if (flagRenderNewConversation) {
            await handleSendMessageManually("", false, false, true, [], payload);
        } else {
            const actionExecutionData = buildTemplateActionExecutionData(messageTemplateDetail, resolvedTemplateVariableData);
            payload = { ...payload, ...(actionExecutionData ? { action_execution_data: actionExecutionData } : {}) };
            handleSendMessageManually("", false, false, true, [], payload);
        }
        setFlagSelectTemplatePopup(false);
    }, [sendTemplatePayload, currentActiveChatbotThread, newThreadInfo, integrationListNewStructure, flagRenderNewConversation, messageTemplateDetail, handleSendMessageManually, setFlagSelectTemplatePopup]);

    // ── Effects ───────────────────────────────────────────────────────────────

    useEffect(() => {
        setMessageTemplateDetail(null);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (messageTemplateDetail) {
            setCreateTemplatePayloadFromDetails(messageTemplateDetail);

            if (isCarouselTemplate(messageTemplateDetail)) {
                const globalHeaderData = messageTemplateDetail?.whtatsapp_carousel_header_variable_data || [];
                const variableArray = setCarouselGlobalHeaderData(globalHeaderData);
                const sortedTemplateData = [...(messageTemplateDetail?.whatsapp_template_data ?? [])].sort(
                    (a: any, b: any) => a.whatsapp_template_carousel_variation_id - b.whatsapp_template_carousel_variation_id
                );
                for (const currentCard of sortedTemplateData) {
                    const currentCardHeaderData = currentCard?.whatsapp_template_header?.whatsapp_template_header_data?.[0]?.whatsapp_template_header_variable_data ?? [];
                    const currentCardHeaderType = currentCard?.whatsapp_template_header?.whatsapp_template_header_type_name || "";
                    const currentCardBodyData = [...(currentCard?.whatsapp_template_body?.whatsapp_template_body_variable_data ?? [])].sort(
                        (a: any, b: any) => a.whatsapp_template_dynamic_variable_id - b.whatsapp_template_dynamic_variable_id
                    );
                    const currentCardButtonData = currentCard?.whatsapp_template_button?.length > 0
                        ? getAllButtonVariableData(currentCard.whatsapp_template_button).sort(
                            (a, b) => a.whatsapp_template_dynamic_variable_id - b.whatsapp_template_dynamic_variable_id
                        )
                        : [];

                    variableArray.push(...setDefaultTemplateVariable(currentCardHeaderData, currentCardHeaderType, currentCardBodyData, currentCardButtonData, [], true));
                }
                setSendTemplatePayload((prev) => ({ ...prev, template_variable_data: variableArray }));
                setCarouselTemplatePayload(buildCarouselTemplatePayload(messageTemplateDetail, [], []));
            } else {
                const bodyData = [...(messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_body?.whatsapp_template_body_variable_data ?? [])].sort(
                    (a, b) => a.whatsapp_template_dynamic_variable_id - b.whatsapp_template_dynamic_variable_id
                );
                const headerData = messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_header?.whatsapp_template_header_data?.[0]?.whatsapp_template_header_variable_data || [];
                const headerType = messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_header?.whatsapp_template_header_type_name || "";

                let currentButtonData: any = [];
                let flowVariables: any[] = [];

                if (messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_button?.length > 0) {
                    currentButtonData = getAllButtonVariableData(messageTemplateDetail.whatsapp_template_data[0].whatsapp_template_button).sort(
                        (a, b) => a.whatsapp_template_dynamic_variable_id - b.whatsapp_template_dynamic_variable_id
                    );
                    setButtonData(getAllButtonVariableData(messageTemplateDetail.whatsapp_template_data[0].whatsapp_template_button));
                }

                if (messageTemplateDetail?.whatsapp_template_flag_flow) {
                    flowVariables = messageTemplateDetail?.whatsapp_template_data?.[0]?.whatsapp_template_button
                        ?.find((btn: any) => btn?.whatsapp_template_button_type_name?.toLowerCase() === "flow")
                        ?.whatsapp_template_button_data?.[0]?.whatsapp_flow_data?.whatsapp_flow_version_data
                        ?.find((version: any) => version?.whatsapp_flow_metadata_response?.whatsapp_flow_meta_status?.toLowerCase() === "published")
                        ?.whatsapp_flow_variables?.filter((flowVar: any) => flowVar?.input_variable_flag) ?? [];
                }

                setDefaultTemplateVariable(headerData, headerType, bodyData, currentButtonData, flowVariables, false);
            }
        } else {
            setCreateTemplatePayload(defaultCreateTemplatePayload(templateCategoryList ?? []));
            setCarouselTemplatePayload(null);
        }
    }, [messageTemplateDetail]); // eslint-disable-line react-hooks/exhaustive-deps

    // ── Render helpers ────────────────────────────────────────────────────────

    const renderTableHeader = () => (
        <TableHead>
            <TableRow>
                <TableCell className={whatsAppCampaignStyles.tableHeadingFontStyle}></TableCell>
                <TableCell className={whatsAppCampaignStyles.tableHeadingFontStyle}>Value</TableCell>
                <TableCell className={whatsAppCampaignStyles.tableHeadingFontStyle}>Fallback Value</TableCell>
            </TableRow>
        </TableHead>
    );

    const renderHeaderValue = (
        headerType: string,
        variable: whatsappTemplateHeaderVariable,
        variableType: string,
        whatsapp_template_carousel_variation_id?: number
    ) => {
        const variableKey = variable?.whatsapp_template_dynamic_variable_key ?? "";
        const isLocationCoordinateField = headerType.toLowerCase() === "location"
            && ["{{latitude}}", "{{longitude}}"].includes(variableKey.toLowerCase());
        const isInvalidLocationCoordinate = isLocationCoordinateField
            && inValidId.includes(variable?.whatsapp_template_dynamic_variable_id);
        const locationCoordinateWarning = isInvalidLocationCoordinate
            ? getLocationCoordinateWarning(variableKey)
            : "";

        return (
            <>
                <Grid item className={globalStyles.fullwidth}>
                    <Grid container className={globalStyles.flexColumn}>
                        <TextField
                            value={sendTemplatePayload.template_variable_data?.find((v) => v?.variable_id === variable?.whatsapp_template_dynamic_variable_id)?.variable_value || ""}
                            placeholder='Enter Value'
                            className={`${whatsAppCampaignStyles.whatsappCampaignTextField} ${globalStyles.fullwidth} ${styles.sendTemplateValueTextField}`}
                            sx={{ border: inValidId.includes(variable?.whatsapp_template_dynamic_variable_id) ? "1px solid red" : "" }}
                            onChange={(e) => handleChangeValue(e.target.value, variableType, variable, whatsapp_template_carousel_variation_id || 0, headerType)}
                        />
                        {(isMediaHeaderType(headerType) && inValidId.includes(variable?.whatsapp_template_dynamic_variable_id)) && (
                            <span className={styles.inValidUrlSpan}>Please Enter Valid URL</span>
                        )}
                        {locationCoordinateWarning && <span className={styles.inValidUrlSpan}>{locationCoordinateWarning}</span>}
                    </Grid>
                </Grid>
                {isMediaHeaderType(headerType) && (
                    <Grid item>
                        <FileUpload
                            uploadedFileDetails={files}
                            multipleFileAllow={true}
                            fileSizeAllowed={getWhatsappMediaSizeLimit(headerType)}
                            fileTypeAllowed={getWhatsappMediaAllowedFileTypes(headerType)?.allowedType}
                            fileNumberAllowed={2}
                            uploadFileHandler={(e) => uploadFileHandler(e, variable, whatsapp_template_carousel_variation_id)}
                            removeFileHandler={removeFileHandler}
                            isDeleteFileIconVisible={isFileUploaded}
                            flagShowJustIcon={true}
                            isDisabled={false}
                            flagWhatsapp={true}
                        />
                    </Grid>
                )}
            </>
        );
    };

    // ── JSX ───────────────────────────────────────────────────────────────────

    return (
        <>
            <Grid container className={globalStyles.fullHeight}>
                <Grid item xs={12}>
                    <Grid container className={`${globalStyles.flexColumn} ${globalStyles.fullHeight} ${globalStyles.flexWrap}`} flexWrap={"nowrap"}>
                        <Grid item className={globalStyles.textCenter}>
                            <Typography className={contactStyle.popupTitleTypography}>Send Template</Typography>
                        </Grid>

                        <Divider className={contactStyle.popupTitleDivider} />

                        <Grid item className={globalStyles.fullHeight}>
                            <Grid container className={globalStyles.fullHeight}>
                                <Grid item xs={12} className={`${globalStyles.relativePosition} ${globalStyles.fullHeight} ${styles.sendTemplatePopupGrid}`}>
                                    <Grid
                                        container
                                        className={`${globalStyles.spaceAlignmentCenter} ${globalStyles.relativePosition} ${globalStyles.fullHeight}`}
                                        gap={{ xs: 0, lg: 1, xl: 2 }}
                                        flexWrap={"nowrap"}
                                        direction={{ xs: "column", lg: "row" }}
                                    >
                                        {flagLargeScreen && (
                                            <Grid item className={whatsAppCampaignStyles.whatsappCampaignPreviewItem} onClick={() => setOpenSwipableDrawer(true)}>
                                                <Grid container className={`${globalStyles.alignItemCenter} ${globalStyles.clickable}`} gap={"5px"}>
                                                    <img src={previewIcon} className={globalStyles.previewIconStyle} alt="" />
                                                    <Typography component={'span'} className={globalStyles.previewIconFont}>Preview</Typography>
                                                </Grid>
                                            </Grid>
                                        )}

                                        {/* Left panel — template selector + variable tables */}
                                        <Grid
                                            item xs={12} lg={7.8} xl={8}
                                            mt={flagLargeScreen ? "40px" : "10px"}
                                            className={`${whatsAppCampaignStyles.whatsappCampaignLeftBox} ${globalStyles.relativePosition} ${globalStyles.overflowAuto} ${styles.sendTemplatePopupInfoGrid}`}
                                            sx={{ height: `${innerHeight}px !important`, minHeight: `${innerHeight}px !important`, maxHeight: `${innerHeight}px !important` }}
                                        >
                                            <Grid container gap="12px">
                                                <Grid item xs={12}>
                                                    <Grid container className={globalStyles.flexColumn} gap={"16px"}>
                                                        <Grid item xs={12}>
                                                            <Grid container gap={"12px"}>
                                                                <Grid item xs={12}>
                                                                    <Typography className={whatsAppCampaignStyles.whatsappCampaignTitleTypography}>
                                                                        Template <Required />
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid item xs={12}>
                                                                    <Autocomplete
                                                                        className={`${contactStyle.contactFilterDropDowns} ${contactStyle.contactFilterDropdownsInPopup}`}
                                                                        options={templateList || []}
                                                                        value={templateList?.find((t) => t.whatsapp_template_id === sendTemplatePayload.whatsapp_template_id) || null}
                                                                        getOptionLabel={(option) => option?.whatsapp_template_data?.[0].whatsapp_template_display_name ?? option?.whatsapp_template_data?.[0]?.whatsapp_template_name}
                                                                        onChange={(_, newValue) => onChangeOfTemplate(newValue)}
                                                                        renderOption={(props, option) => renderTemplateOptions(props, option, option.whatsapp_template_id)}
                                                                        renderInput={(params) => <TextField {...params} placeholder="Select Template" />}
                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>

                                                {(sendTemplatePayload.whatsapp_template_id !== 0 && messageTemplateDetail) && (
                                                    <Grid
                                                        item xs={12} gap="12px"
                                                        className={`${globalStyles.overflowAuto} ${globalStyles.fullwidth} ${globalStyles.maxWidthFull} ${globalStyles.boxSizingBorderBox} ${styles.sendTemplateAssignVariableGrid}`}
                                                        sx={{ backgroundColor: (flagShowHeaderVariables || flagShowBodyVariable || flagShowButtonVariable || flagShowInputFlowVariabless ? "#f4f4f4" : isCarouselTemplate(messageTemplateDetail)) ? "#fafafa" : "" }}
                                                    >
                                                        {!isCarouselTemplate(messageTemplateDetail) ? (
                                                            <>
                                                                {/* Header variables */}
                                                                {flagShowHeaderVariables && (
                                                                    <Grid container className={globalStyles.flexColumn} mb="10px">
                                                                        <Grid item>
                                                                            <Typography className={whatsAppCampaignStyles.assignValuesTitle}>
                                                                                Assign Values to Template Header Variables <Required />
                                                                            </Typography>
                                                                        </Grid>
                                                                        <Grid item className={`${globalStyles.fullwidth} ${styles.sendTemplateAssignVariableTableGrid}`}>
                                                                            <TableContainer className={`${globalStyles.fullwidth} ${globalStyles.boxSizingBorderBox} ${globalStyles.overflowAuto} ${globalStyles.maxWidthFull}`}>
                                                                                <Table>
                                                                                    {renderTableHeader()}
                                                                                    <TableBody>
                                                                                        {messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_header.whatsapp_template_header_data[0].whatsapp_template_header_variable_data.map((variable) => (
                                                                                            <TableRow key={variable.whatsapp_template_dynamic_variable_id} className={whatsAppCampaignStyles.tableRow}>
                                                                                                <TableCell className={whatsAppCampaignStyles.tableSubHeadingFontStyle}>{variable.whatsapp_template_dynamic_variable_key}</TableCell>
                                                                                                <TableCell className={whatsAppCampaignStyles.tableSubHeadingFontStyle}>
                                                                                                    {isHeaderTypeLocation ? "-" : (
                                                                                                        <Autocomplete
                                                                                                            className={`${whatsAppCampaignStyles.whatsappCampaignDropDowns} ${globalStyles.fullwidth} ${styles.sendTemplateValueAutoComplete}`}
                                                                                                            options={metaDataOptions}
                                                                                                            getOptionLabel={(option) => option}
                                                                                                            value={sendTemplatePayload.template_variable_data?.find((v) => v?.variable_id === variable?.whatsapp_template_dynamic_variable_id)?.variable_replaced_value ?? null}
                                                                                                            onChange={(_, value) => onChangeOfValue(value, variable)}
                                                                                                            renderInput={(params) => <TextField {...params} placeholder="Select" />}
                                                                                                        />
                                                                                                    )}
                                                                                                </TableCell>
                                                                                                <TableCell className={whatsAppCampaignStyles.tableSubHeadingFontStyle}>
                                                                                                    <Grid container gap={"5px"} className={globalStyles.fullwidth} flexWrap={"nowrap"}>
                                                                                                        {renderHeaderValue(messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_header.whatsapp_template_header_type_name, variable, "header")}
                                                                                                    </Grid>
                                                                                                </TableCell>
                                                                                            </TableRow>
                                                                                        ))}
                                                                                    </TableBody>
                                                                                </Table>
                                                                            </TableContainer>
                                                                        </Grid>
                                                                    </Grid>
                                                                )}

                                                                {/* Body variables */}
                                                                {flagShowBodyVariable && (
                                                                    <Grid container className={globalStyles.flexColumn} mb="10px">
                                                                        <Grid item>
                                                                            <Typography className={whatsAppCampaignStyles.assignValuesTitle}>
                                                                                Assign Values to Template Body Variables <Required />
                                                                            </Typography>
                                                                        </Grid>
                                                                        <Grid item className={`${globalStyles.fullwidth} ${styles.sendTemplateAssignVariableTableGrid}`}>
                                                                            <TableContainer className={`${globalStyles.fullwidth} ${globalStyles.boxSizingBorderBox} ${globalStyles.overflowAuto} ${globalStyles.maxWidthFull}`}>
                                                                                <Table>
                                                                                    {renderTableHeader()}
                                                                                    <TableBody>
                                                                                        {messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_body.whatsapp_template_body_variable_data
                                                                                            .slice()
                                                                                            .sort((a, b) => a.whatsapp_template_dynamic_variable_id - b.whatsapp_template_dynamic_variable_id)
                                                                                            .map((variable) => (
                                                                                                <TableRow key={variable.whatsapp_template_dynamic_variable_id} className={whatsAppCampaignStyles.tableRow}>
                                                                                                    <TableCell className={whatsAppCampaignStyles.tableSubHeadingFontStyle}>{variable.whatsapp_template_dynamic_variable_key}</TableCell>
                                                                                                    <TableCell className={whatsAppCampaignStyles.tableSubHeadingFontStyle}>
                                                                                                        <Autocomplete
                                                                                                            className={`${whatsAppCampaignStyles.whatsappCampaignDropDowns} ${globalStyles.fullwidth} ${styles.sendTemplateValueAutoComplete}`}
                                                                                                            options={metaDataOptions}
                                                                                                            getOptionLabel={(option) => option}
                                                                                                            value={sendTemplatePayload.template_variable_data?.find((v) => v?.variable_id === variable?.whatsapp_template_dynamic_variable_id)?.variable_replaced_value ?? null}
                                                                                                            onChange={(_, value) => onChangeOfValue(value, variable)}
                                                                                                            renderInput={(params) => <TextField {...params} placeholder="Select" />}
                                                                                                        />
                                                                                                    </TableCell>
                                                                                                    <TableCell className={whatsAppCampaignStyles.tableSubHeadingFontStyle}>
                                                                                                        <TextField
                                                                                                            value={sendTemplatePayload.template_variable_data?.find((v) => v?.variable_id === variable?.whatsapp_template_dynamic_variable_id)?.variable_value || ""}
                                                                                                            placeholder='Enter Value'
                                                                                                            className={`${whatsAppCampaignStyles.whatsappCampaignTextField} ${globalStyles.fullwidth} ${styles.sendTemplateValueTextField}`}
                                                                                                            onChange={(e) => handleChangeValue(e.target.value, "body", variable, 0)}
                                                                                                        />
                                                                                                    </TableCell>
                                                                                                </TableRow>
                                                                                            ))}
                                                                                    </TableBody>
                                                                                </Table>
                                                                            </TableContainer>
                                                                        </Grid>
                                                                    </Grid>
                                                                )}

                                                                {/* Button variables */}
                                                                {flagShowButtonVariable && (
                                                                    <Grid container className={globalStyles.flexColumn}>
                                                                        <Grid item>
                                                                            <Typography className={whatsAppCampaignStyles.assignValuesTitle}>
                                                                                Assign Values to Template Button Variables <Required />
                                                                            </Typography>
                                                                        </Grid>
                                                                        <Grid item className={`${globalStyles.fullwidth} ${styles.sendTemplateAssignVariableTableGrid}`}>
                                                                            <TableContainer className={`${globalStyles.fullwidth} ${globalStyles.boxSizingBorderBox} ${globalStyles.overflowAuto} ${globalStyles.maxWidthFull}`}>
                                                                                <Table>
                                                                                    {renderTableHeader()}
                                                                                    <TableBody>
                                                                                        {buttonData?.slice().sort((a, b) => a.whatsapp_template_dynamic_variable_id - b.whatsapp_template_dynamic_variable_id).map((variable, ind) => {
                                                                                            const updatedIndex = updatedIndexForBtnVariable(ind);
                                                                                            return (
                                                                                                <TableRow key={variable.whatsapp_template_dynamic_variable_id} className={whatsAppCampaignStyles.tableRow}>
                                                                                                    <TableCell className={whatsAppCampaignStyles.tableSubHeadingFontStyle}>{variable.whatsapp_template_dynamic_variable_key}</TableCell>
                                                                                                    <TableCell className={whatsAppCampaignStyles.tableSubHeadingFontStyle}>
                                                                                                        <Autocomplete
                                                                                                            className={`${whatsAppCampaignStyles.whatsappCampaignDropDowns} ${globalStyles.fullwidth} ${styles.sendTemplateValueAutoComplete}`}
                                                                                                            options={metaDataOptions}
                                                                                                            getOptionLabel={(option) => option}
                                                                                                            value={sendTemplatePayload.template_variable_data?.find((v) => v?.variable_id === variable?.whatsapp_template_dynamic_variable_id)?.variable_replaced_value ?? null}
                                                                                                            onChange={(_, value) => onChangeOfValue(value, variable)}
                                                                                                            renderInput={(params) => <TextField {...params} placeholder="Select" />}
                                                                                                        />
                                                                                                    </TableCell>
                                                                                                    <TableCell className={whatsAppCampaignStyles.tableSubHeadingFontStyle}>
                                                                                                        <Grid container className={globalStyles.flexColumn}>
                                                                                                            <TextField
                                                                                                                value={sendTemplatePayload.template_variable_data?.find((v) => v?.variable_id === variable?.whatsapp_template_dynamic_variable_id)?.variable_value || ""}
                                                                                                                placeholder={`Enter the value of variable for ${getVisitWebsiteUrl(messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_button, variable.whatsapp_template_dynamic_variable_id)}`}
                                                                                                                className={`${whatsAppCampaignStyles.whatsappCampaignTextField} ${globalStyles.fullwidth} ${styles.sendTemplateValueTextField}`}
                                                                                                                sx={{ border: inValidId.includes(updatedIndex) ? "1px solid red" : "" }}
                                                                                                                onChange={(e) => handleChangeValue(e.target.value, "button", variable, 0)}
                                                                                                            />
                                                                                                        </Grid>
                                                                                                    </TableCell>
                                                                                                </TableRow>
                                                                                            );
                                                                                        })}
                                                                                    </TableBody>
                                                                                </Table>
                                                                            </TableContainer>
                                                                        </Grid>
                                                                    </Grid>
                                                                )}

                                                                {/* Flow input variables */}
                                                                {flagShowInputFlowVariabless && (
                                                                    <Grid container className={globalStyles.flexColumn}>
                                                                        {whatsappFlowData?.filter((waFlow) =>
                                                                            waFlow?.whatsapp_flow_version_data?.some(
                                                                                (version) =>
                                                                                    version?.whatsapp_flow_metadata_response?.whatsapp_flow_meta_status?.toLowerCase() === "published" &&
                                                                                    version?.whatsapp_flow_variables?.some((v) => v?.input_variable_flag)
                                                                            )
                                                                        ).map((waFlow: WhatsappFlow, waFlowIndex) => (
                                                                            <React.Fragment key={waFlowIndex}>
                                                                                <Grid item>
                                                                                    <Typography className={whatsAppCampaignStyles.assignValuesTitle}>
                                                                                        Assign Values to Flow Input Variables <Required />
                                                                                    </Typography>
                                                                                </Grid>
                                                                                <Grid item className={`${globalStyles.fullwidth} ${styles.sendTemplateAssignVariableTableGrid}`}>
                                                                                    <TableContainer className={`${globalStyles.fullwidth} ${globalStyles.boxSizingBorderBox} ${globalStyles.overflowAuto} ${globalStyles.maxWidthFull}`}>
                                                                                        <Table>
                                                                                            {renderTableHeader()}
                                                                                            <TableBody>
                                                                                                {waFlow?.whatsapp_flow_version_data
                                                                                                    ?.find((version) => version?.whatsapp_flow_metadata_response?.whatsapp_flow_meta_status?.toLowerCase() === "published")
                                                                                                    ?.whatsapp_flow_variables
                                                                                                    ?.filter((v) => v?.input_variable_flag)
                                                                                                    ?.map((variable) => (
                                                                                                        <TableRow key={variable.whatsapp_flow_variable_id} className={whatsAppCampaignStyles.tableRow}>
                                                                                                            <TableCell className={whatsAppCampaignStyles.tableSubHeadingFontStyle}>{variable.variable_key}</TableCell>
                                                                                                            <TableCell className={whatsAppCampaignStyles.tableSubHeadingFontStyle}>
                                                                                                                <Autocomplete
                                                                                                                    className={`${whatsAppCampaignStyles.whatsappCampaignDropDowns} ${globalStyles.fullwidth} ${styles.sendTemplateValueAutoComplete}`}
                                                                                                                    options={metaDataOptions}
                                                                                                                    getOptionLabel={(option) => option}
                                                                                                                    value={sendTemplatePayload.template_variable_data?.find((v) => v?.variable_id === variable?.whatsapp_flow_variable_id)?.variable_replaced_value ?? null}
                                                                                                                    onChange={(_, value) => onChangeOfValue(value, variable)}
                                                                                                                    renderInput={(params) => <TextField {...params} placeholder="Select" />}
                                                                                                                />
                                                                                                            </TableCell>
                                                                                                            <TableCell className={whatsAppCampaignStyles.tableSubHeadingFontStyle}>
                                                                                                                <TextField
                                                                                                                    value={sendTemplatePayload.template_variable_data?.find((v) => v?.variable_id === variable?.whatsapp_flow_variable_id)?.variable_value || ""}
                                                                                                                    placeholder="Enter the value"
                                                                                                                    className={`${whatsAppCampaignStyles.whatsappCampaignTextField} ${globalStyles.fullwidth} ${styles.sendTemplateValueTextField}`}
                                                                                                                    onChange={(e) => handleChangeValue(e.target.value, "flow", variable, 0)}
                                                                                                                />
                                                                                                            </TableCell>
                                                                                                        </TableRow>
                                                                                                    ))}
                                                                                            </TableBody>
                                                                                        </Table>
                                                                                    </TableContainer>
                                                                                </Grid>
                                                                            </React.Fragment>
                                                                        ))}
                                                                    </Grid>
                                                                )}
                                                            </>
                                                        ) : (
                                                            <CarouselTemplateVariableMapping
                                                                sendTemplatePayload={sendTemplatePayload}
                                                                messageTemplateDetail={messageTemplateDetail}
                                                                renderTableHeader={renderTableHeader}
                                                                onChangeOfValue={onChangeOfValue}
                                                                handleChangeValue={handleChangeValue}
                                                                renderHeaderValue={renderHeaderValue}
                                                                getAllButtonVariableData={getAllButtonVariableData}
                                                                getMetaDataOptions={() => metaDataOptions}
                                                            />
                                                        )}
                                                    </Grid>
                                                )}
                                            </Grid>
                                        </Grid>

                                        {/* Action buttons */}
                                        <Grid item xs={12} className={styles.sendTemplateBtnGroupGrid}>
                                            <Grid container gap={"12px"} className={globalStyles.alignItemCenter}>
                                                <Grid item>
                                                    <GlobalButton
                                                        buttonText={"Cancel"}
                                                        sx={{ width: flagTabletScreen ? "100px" : "140px" }}
                                                        className='borderedButtonStyle'
                                                        onClick={onClickOfCancel}
                                                    />
                                                </Grid>
                                                <Grid item>
                                                    <GlobalButton
                                                        buttonText={"Send"}
                                                        sx={{ width: flagTabletScreen ? "100px" : "140px" }}
                                                        disabled={isDisabledSendBtn}
                                                        className='primaryButtonStyle'
                                                        onClick={onClickOfSend}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        {/* Desktop preview panel */}
                                        {!flagLargeScreen && (
                                            <Grid item xs={12} lg={4} xl={3.5}>
                                                <Grid container className={`${globalStyles.flexColumn} ${globalStyles.justifyCenter}`}>
                                                    <Grid item>
                                                        {isCarouselTemplate(messageTemplateDetail) ? (
                                                            <TemplatePreviewCarouselView metaInformation={carouselTemplatePayload} flagTemplatePopup={true} />
                                                        ) : (
                                                            <BasicTemplatePreview metaInformation={createTemplatePayload} flagTemplatePopup={true} wabaName={wabaName} />
                                                        )}
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        )}

                                        {/* Mobile/tablet swipeable preview panel */}
                                        {flagLargeScreen && (
                                            <Grid item xs={12} className={globalStyles.relativePosition}>
                                                {isCarouselTemplate(messageTemplateDetail) ? (
                                                    <TemplatePreviewCarouselMobileView
                                                        metaInformation={carouselTemplatePayload}
                                                        flagSmallScreen={flagLargeScreen}
                                                        flagPositionRelative={true}
                                                        setOpenSwipableDrawer={setOpenSwipableDrawer}
                                                        openSwipableDrawer={openSwipableDrawer}
                                                        toggleDrawer={toggleDrawer}
                                                    />
                                                ) : (
                                                    <TemplatePreviewMobile
                                                        metaInformation={createTemplatePayload}
                                                        flagSmallScreen={flagLargeScreen}
                                                        flagPositionRelative={true}
                                                        setOpenSwipableDrawer={setOpenSwipableDrawer}
                                                        openSwipableDrawer={openSwipableDrawer}
                                                        toggleDrawer={toggleDrawer}
                                                        wabaName={wabaName}
                                                    />
                                                )}
                                            </Grid>
                                        )}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
};

export default SelectTemplatePopup;
